// Tiny AngularJS module to keep track of Laravel dependencies
/* global laroute: false */

angular.module('laravel', [])
.factory('laroute', function() {
    return laroute;
});
